import React from 'react'
import { useFormatMessage } from '@babylon/intl'
import { logException } from '@babylon/sentry'
import classNames from 'classnames/bind'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { useHistory } from 'react-router-dom'
import Template from '../Template'
import { onboardingSteps } from './steps'
import GpForm from '@/views/GpDetails/components/GpForm'
import Loading from '@/components/Loading'
import ClinicalUserInformationQuery from '@/queries/ClinicalUserInformation'
import UpdateGPMutation from '@/mutations/UpdateGP'
import { useCurrentUserId } from '@/redux/selectors'
import styles from '@/views/GpDetails/GpDetails.module.scss'
import messages from '../messages'
import gpMessages from '@/views/GpDetails/GpDetails.messages'
import { checkoutRoutes } from '@/programmes/WeightLoss/routes'

const cx = classNames.bind(styles)

const GpDetails = () => {
  const t = useFormatMessage()
  const history = useHistory()
  const currentUserId = useCurrentUserId()
  const userData = useQuery(ClinicalUserInformationQuery, {
    variables: {
      id: currentUserId,
    },
  })
  const [updateGP] = useMutation(UpdateGPMutation, {
    context: {
      showFeedback: {
        success: gpMessages.success,
        failure: true,
      },
    },
  })

  const onSubmit = async (fields) => {
    updateGP({
      variables: {
        id: currentUserId,
        formData: {
          ...fields,
        },
      },
    })
      .then(() => history.push(checkoutRoutes.home))
      .catch(logException)
  }

  if (userData.loading) {
    return <Loading />
  }

  const gpDetailsAlreadyOnFile = !!userData.data?.clinicalUserInformation
    ?.gp_name

  // Core Ruby always allows updating the GP details when it's empty so setting to false
  // Otherwise it's best effort, in case it fails the user can skip
  const isUpdateDisabled = false

  return (
    <Template
      title={t(gpMessages.pageTitle)}
      steps={onboardingSteps}
      activeStep={0}
    >
      <h2 className={cx('heading')}>{t(gpMessages.pageTitle)}</h2>
      <p className={cx('description')}>{t(messages.gpDetailsNeeded)}</p>
      <section className={cx('Content--narrow', styles.GpDetailsPage)}>
        <GpForm
          isUpdateDisabled={isUpdateDisabled}
          onSubmit={onSubmit}
          onCancel={() => history.push(checkoutRoutes.home)}
          clinicalUserInformation={userData.data?.clinicalUserInformation}
          regionId={userData.data?.clinicalUserInformation?.region?.id}
          options={{
            submitBtnText: t(gpMessages.gpAtHandSubmitButtonText),
            cancelBtnText: t(
              gpDetailsAlreadyOnFile
                ? messages.gpDetailsSkip
                : messages.gpDetailsNoGp
            ),
          }}
        />
      </section>
    </Template>
  )
}

export default GpDetails
